var map = {
	"./diamond-clarity-1@2x.png": 88,
	"./diamond-clarity-2@2x.png": 90,
	"./diamond-clarity-3@2x.png": 92,
	"./diamond-clarity-4@2x.png": 94,
	"./diamond-clarity-5@2x.png": 96
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 259;